import pako from "pako";
import util from "@/mixins/util";
let apiKey = 'key_live_esoRNKUaOMrMXQ2rNoAaGnbdtqjsmiSX'

export default {
    methods: {
        createLink(route) {
            let params = {
                branch_key: apiKey,
                /*data: {
                    'deeplink_path': '/'
                },*/
                data: route,
            }
            const options = {
                method: 'POST',
                headers: {accept: 'application/json', 'content-type': 'application/json'},
                body: JSON.stringify(params)
            };

            return fetch('https://api2.branch.io/v1/url', options).then(response => response.json()).then(response => response.url)
                .catch((err, trace) => {
                    function mapQueryStringParameters (params) {
                        return ('?' + Object.entries(params)
                                .flatMap(([key, value]) => [value].flat().filter(v => v !== "").map(v => [key, v])).map(it => it.join("="))
                                .join("&")
                        ).replace(/^.$/, "") // Remove lonely "?"
                    }
                    console.log(err);
                    return `https://rainbowtv.app.link${mapQueryStringParameters(route)}`;
                });
        },
        async checkRouteInviteCode() {
            if(this.$route.query.hasOwnProperty('_branch_referrer')) {
                let referrer = this.$route.query._branch_referrer;
                let url = this.decodeBranchReferrer(referrer);
                let result = await this.decodedBranchShortLink(url)
                if(!util.isEmpty(result.data) && !util.isEmpty(result.data.deeplink_path) && !util.isEmpty(result.data.code)) {
                    let inviteCode = {'route': result.data.deeplink_path, 'code': result.data.code};
                    return inviteCode;
                }
                return null;
            }
            return new Promise(resolve => resolve(null));
        },
        async checkRouteSnsCode() {
            if(this.$route.query.hasOwnProperty('_branch_referrer')) {
                let referrer = this.$route.query._branch_referrer;
                let url = this.decodeBranchReferrer(referrer);
                let result = await this.decodedBranchShortLink(url)
                if(!util.isEmpty(result.data) && !util.isEmpty(result.data.csk) && !util.isEmpty(result.data.url)) {
                    let csk = result.data.csk.split(' ')[0].replace(/[^a-zA-Z0-9]/g, "");
                    let referring_browser = result.data['~referring_browser'];
                    let snsCode = {'code': `https://rainbowtv.app.link/?csk=${csk}&~referring_browser=${referring_browser}`};
                    return snsCode;
                }
                return null;
            }
            return new Promise(resolve => resolve(null));
        },
        decodeBranchReferrer(referrer) {
            const urlDecoded = decodeURIComponent(referrer);

            // 2) Base64 decode → Uint8Array
            const binStr = atob(urlDecoded);
            const bytes = new Uint8Array(binStr.length);
            for (let i = 0; i < binStr.length; i++) bytes[i] = binStr.charCodeAt(i);

            // 3) gunzip (pako 사용)
            // npm i pako
            const { ungzip } = window.pako ?? pako;
            const ungz = ungzip(bytes, { to: "string" });
            return decodeURIComponent(ungz);
        },
        decodedBranchShortLink(url) {
            const options = {
                method: 'GET',
                headers: {accept: 'application/json', 'content-type': 'application/json'},

            };

            let queryString = new URLSearchParams({branch_key: apiKey, url: url,}).toString();

            return fetch('https://api2.branch.io/v1/url?' + queryString, options).then(response => response.json()).then(response => response)
                .catch((err, trace) => {
                    console.log(err);
                    return {};
                });
        },
        checkLocalStorageInviteCode() {
            try {
                let inviteDecode = this.$localStorage.get('inviteCode')
                if(util.isEmpty(inviteDecode)) return false;
                let inviteCodeString = atob(inviteDecode);
                let inviteCode = JSON.parse(inviteCodeString);
                if(inviteCode.hasOwnProperty('route') && inviteCode.hasOwnProperty('code') && inviteCode.route == 'referral') {
                    this.$localStorage.remove('inviteCode')
                    return inviteCode;
                }
                this.$localStorage.remove('inviteCode')
                return null;
            }catch (e) {
                return null;
            }finally {

            }

        },
    },
}
